export default {
  key: "pt_PT",
  主頁: "Página Inicia",
  日期: "Data",
  時間: "Hora",
  地點: "Local",
  對象: "Destinatários ",
  語言: "Língua",
  報名: "Inscrição",
  查詢: "informação",
  主辦: "Organizador",
  更多: "Mais info",
  活動資訊: "Actividades",
  媒體發佈: "Notícias",
  聯繫我們: "Contato",
  共讀活動: "Actividades de leitura",
  共讀點: "Pontos de Leitura",
  全城共讀: "Lendo em Toda a Cidade",
  协办单位: "Co-Organização",
  返回: "Voltar",
  預熱活動: "Actividades de aquecimento",
  澳門圖書館周: "Semana da Biblioteca de Macau",
  "澳門全城共讀月-啟動儀式": "Cerimónia de início",
  其他活動: "Série de actividades",
  聯絡我們: "Contato",
  專題講座: "Palestra temática",
  讀書會: "Clube de leitura",
  室內活動: "Actividades em recintos interiores",
  戶外廣場活動: "Actividades ao ar livre na praça",
  戶外廣場舞台節目: "Espectáculos de palco ao ar livre na praça",
  更多活動詳情即將公佈: "Mais detalhes serão anunciados em breve.",
  過往精彩照片 : "過往精彩照片pt",
};
